//
//
//
//
//
//

import Prism from 'prismjs';
import 'prismjs/components/prism-json';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  name: 'CodeViewer',
  props: {
    code: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.setUpPrism();
  },
  methods: {
    setUpPrism() {
      Prism.highlightAll();
    }
  }
};
